export default __webpack_public_path__ + "static/media/allergy.7b8a64e9.png";